import { render, staticRenderFns } from "./StudentCenter.vue?vue&type=template&id=5c7f7e62&scoped=true&"
import script from "./StudentCenter.vue?vue&type=script&lang=js&"
export * from "./StudentCenter.vue?vue&type=script&lang=js&"
import style0 from "./StudentCenter.vue?vue&type=style&index=0&id=5c7f7e62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f7e62",
  null
  
)

export default component.exports